import React from 'react';
import { get } from 'lib/comms';
import TextField from '@material/react-text-field';
import Table from 'components/Table/Table';
import TrustSubmissionItem from './TrustSubmissionItemPage';
import './TrustSubmission.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faChevronRight, faMinusCircle } from '@fortawesome/free-solid-svg-icons';

export default class TrustSubmissionPage extends React.Component {
    columns = [
        {
            name: 'ID',
            grow: 2,
            selector: 'id',
            sortable: true,
            wrap: true,
        },
        {
            name: 'Trust Name',
            grow: 4,
            cell: (row) => {
                const organisation = this.state.organisations.find(
                    (org) => String(org.id) === String(row.organisation_id),
                );

                return organisation ? organisation.company_name : row.organisation_id;
            },
        },
        {
            name: 'Submitted',
            selector: 'is_submitted',
            sortable: false,
            grow: 1,
            right: true,
            cell: (row) => (row.is_submitted ? 'Yes' : 'No'),
        },
        {
            name: 'Approved',
            selector: 'is_approved',
            sortable: false,
            grow: 1,
            right: true,
            cell: (row) => (row.is_approved ? 'Yes' : 'No'),
        },
    ];
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            files: [],
            editing: null,
            stepIndex: 0,
            organisations: [],
        };
    }

    componentDidMount = () => {
        this.reload();
        this.fetchOrganisations();
    };

    fetchOrganisations = async () => {
        const organisations = await this.getOrganisations();
        this.setState({ organisations });
    };

    getOrganisations = async () => {
        const resp = await get('cms/organisations', null, true);

        if (resp && resp.status === 401) {
            this.setState({ logout: true });
        }

        return resp && resp.organisations ? resp.organisations : resp && resp.data ? resp.data : [];
    };

    reload = async () => {
        let resp = await get('cms/trust_submission', null, true);
        if (resp && resp.status === 401) this.setState({ logout: true });
        if (resp && resp.success) {
            this.setState({ data: resp.data });
        } else {
            if (resp && resp.status === 400) {
                this.setState({ data: [] });
            } else {
                console.log(resp);
            }
        }
    };

    // update item on change of any item params
    updatePromoBannerItem = (item) => {
        this.setState({
            ...item,
        });
    };

    doneEditing = () => {
        this.setState({ editing: null });
        this.reload();
    };

    render() {
        let { data, search, editing, files, isNew } = this.state;

        return (
            <>
                {this.state.editing ? (
                    <TrustSubmissionItem
                        trustSubmissionItem={editing}
                        onBack={this.doneEditing}
                        files={files}
                        updateTrustSubmissionItem={this.updateTrustSubmissionItem}
                    />
                ) : (
                    <div className="maincontainer">
                        <h4>Trust Submission</h4>
                        <button
                            className={'btn btn-primary mb-4'}
                            disabled={editing}
                            style={{ float: 'right', right: '10px' }}
                            onClick={() => this.setState({ editing: { id: 'new' } })}
                        >
                            <FontAwesomeIcon icon={faPlusCircle} style={{ marginRight: '10px' }} />
                            ADD NEW TRUST SUBMISSION
                        </button>
                        <Table
                            columns={this.columns}
                            data={data}
                            onRowClicked={(item) => this.setState({ editing: item })}
                            tableID="trustSubmission"
                            defaultSortField={this.columns[0].selector}
                        />
                    </div>
                )}
            </>
        );
    }
}
